module.exports = __webpack_public_path__ + "img/bg-06.a2f64254.png";